import { isRejectedWithValue } from "@reduxjs/toolkit";
import { DEFAULT_NOTIFICATION_PAYLOAD, NOTIFICATION_VARIANTS } from "@/utils/applicationConstants";
import { showNotification } from "../actions/notification";

export const requestErrorMiddleware = api => next => action => {
  if (isRejectedWithValue(action)) {
    const status = action.payload?.status;

    // Detect if we are on a capworks route
    const isCapworksRoute = window.location.pathname.startsWith("/capworks");

    // Handle 401 Unauthorized - redirect to forbidden page
    if (status === 401) {
      const errorMessage = encodeURIComponent(
        "Your session has expired or you are not authenticated. Please log in again.",
      );

      // eslint-disable-next-line no-console
      console.log("[RTK Error Middleware] 401 Unauthorized - redirecting to forbidden page");

      // Use setTimeout to allow the action to complete before redirecting
      setTimeout(() => {
        if (isCapworksRoute) {
          const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.href = `/capworks/login?returnUrl=${returnUrl}`;
        } else {
          window.location.href = `/forbidden?error=${errorMessage}&status=401`;
        }
      }, 0);

      return next(action);
    }

    // Handle 403 Forbidden - redirect to forbidden page
    if (status === 403) {
      const errorMessage = encodeURIComponent("You do not have permission to access this resource.");

      // eslint-disable-next-line no-console
      console.log("[RTK Error Middleware] 403 Forbidden - redirecting to forbidden page");

      // Use setTimeout to allow the action to complete before redirecting
      setTimeout(() => {
        if (isCapworksRoute) {
          const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
          window.location.href = `/capworks/login?returnUrl=${returnUrl}`;
        } else {
          window.location.href = `/forbidden?error=${errorMessage}&status=403`;
        }
      }, 0);

      return next(action);
    }

    // For other errors, show notification (unless endpoint opted out)
    if (action.payload?.data && !action.meta?.baseQueryMeta?.suppressNotification)
      api.dispatch(
        showNotification({
          ...DEFAULT_NOTIFICATION_PAYLOAD,
          message: {
            title: "Error",
            description: action.payload.data.userDescription,
            options: {
              variant: NOTIFICATION_VARIANTS.ERROR,
            },
          },
        }),
      );
  }

  return next(action);
};
